@if (chrome === "menu") {
  @if (type === "inputData") {
    <div
      [ngClass]="{
        'button-list': true,
        'button-disabled': isEmpty
      }"
      [matTooltip]="inputData.label"
    >
      <div class="icon">
        <svg-icon [name]="icon"></svg-icon>
      </div>
      <div class="txt">
        {{ inputData.label || "" }}
      </div>
    </div>
  }

  @if (type !== "inputData" && iconOnly) {
    <div
      [ngClass]="{
        'button-list icon-only': true,
        'button-list-active': activeData || icon === 'slider',
        'button-disabled': icon === 'add-incident' && isEmpty
      }"
      [matTooltip]="
        icon === 'add-incident'
          ? undefined
          : ('element.title.' + label | translate)
      "
      #buttonList
      mat-button
      [matMenuTriggerFor]="
        icon === 'add-incident' && isEmpty ? undefined : menuHeader
      "
      (menuOpened)="opened()"
    >
      <div class="icon only">
        @if (!isEmpty || icon === "add-incident") {
          <svg-icon
            [class]="
              activeData || icon === 'slider'
                ? 'button-list-icon-only-active'
                : 'button-list-icon-only'
            "
            [name]="icon"
          ></svg-icon>
        }
        @if (isEmpty && icon !== "add-incident") {
          <mat-spinner
            [diameter]="16"
            class="button-list-icon-only"
          ></mat-spinner>
        }
      </div>
      <div class="icon only">
        <mat-icon>expand_more</mat-icon>
      </div>
    </div>
  }

  @if (type !== "inputData" && !iconOnly) {
    <div
      [ngClass]="{
        'button-list': true,
        'button-list-active': activeData || icon === 'slider',
        'button-disabled': isEmpty
      }"
      #buttonList
      mat-button
      [matMenuTriggerFor]="menuHeader"
      (menuOpened)="opened()"
    >
      <div class="icon">
        @if (!isEmpty) {
          <svg-icon
            [class]="
              activeData || icon === 'slider'
                ? 'button-list-icon-active'
                : 'button-list-icon'
            "
            [name]="icon"
          ></svg-icon>
        }
        @if (isEmpty) {
          <mat-spinner [diameter]="16"></mat-spinner>
        }
      </div>
      <div class="txt">
        {{ "element.title." + label | translate }}
      </div>
      <div class="icon">
        @if (!activeData) {
          <mat-icon>expand_more</mat-icon>
        }
        @if (activeData) {
          <p
            [ngClass]="{
              'button-icon-number': true,
              'button-icon-disabled': isEmpty
            }"
          >
            {{ activeData < 100 ? activeData : "99+" }}
          </p>
        }
      </div>
    </div>
  }

  <mat-menu
    class="button-list-matmenu"
    #menuHeader="matMenu"
    (closed)="applyClosed()"
  >
    <!-- The chrome class scopes the menu half of the styles; the controls
         themselves are the same markup the panel chrome renders. -->
    <div class="chrome-menu">
      <ng-container [ngTemplateOutlet]="controls"></ng-container>

      <app-filter-button-footer
        (clearItems)="clearItems()"
        (applyItems)="applyItems($event)"
        (displayMore)="ondisplayMore()"
        [isNewIncident]="label === 'addIncident' && !checkedData?.length"
        [type]="type"
        [label]="label"
        [isLoading]="isLoading"
        [showAllVariant]="showAllVariant"
        [menuTrigger]="trigger"
      ></app-filter-button-footer>
    </div>
  </mat-menu>
} @else if (chrome === "detail") {
  <!--
    The sidenav's drill-down view: one filter filling the whole sidebar body.
    It keeps `chrome-panel` because every search-bar and table rule the sidenav
    look is made of is scoped under that class; `chrome-detail` only turns the
    list into its own scroller, since here there is a full height to fill.
  -->
  <div class="filter-panel-content chrome-panel chrome-detail">
    <ng-container [ngTemplateOutlet]="controls"></ng-container>
  </div>
} @else {
  <div>
    <mat-expansion-panel
      #panel
      class="sidenav-section"
      hideToggle
      [expanded]="expanded"
      (opened)="opened()"
      (closed)="applyClosed()"
    >
      <mat-expansion-panel-header collapsedHeight="40px" expandedHeight="40px">
        <mat-panel-title class="filter-header-panel">
          <div class="filter-top-part">
            <div class="filter-icon">
              <svg-icon [name]="icon"></svg-icon>
            </div>
            <span class="filter-label">{{
              "element.title." + label | translate
            }}</span>
            <span class="spacer"></span>
            @if (activeData && type !== "radio") {
              <span class="filter-badge">{{
                activeData < 100 ? activeData : "99+"
              }}</span>
            }
            <mat-icon class="chevron">chevron_right</mat-icon>
          </div>
          <!-- Summary visible uniquement quand le panel est fermé -->
          <div class="filter-bottom-part">
            @if (
              !panel.expanded && type === "checkbox" && checkedData?.length
            ) {
              <span class="filter-summary-inline">
                {{ getSummaryText() }}
              </span>
            }
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filter-panel-content chrome-panel">
        <ng-container [ngTemplateOutlet]="controls"></ng-container>
      </div>
    </mat-expansion-panel>
  </div>
}

<!--
  One body for both chromes: which control a filter shows is decided by `type`,
  never by where the filter is rendered. Everything that used to differ between
  the dropdown and the sidenav is either chrome (above) or an input — `chrome`
  for apply timing, `searchable` for the short static lists that have nothing to
  search.
-->
<ng-template #controls>
  @if (type === "checkbox" || type === "label") {
    <div (click)="$event.stopPropagation()">
      @if (searchable) {
        <div class="bar">
          <mat-icon class="searchicon">search</mat-icon>
          <input
            class="searchbar"
            #search
            type="text"
            title="Search"
            [(ngModel)]="searchValue"
            (ngModelChange)="this.searchValueUpdate.next($event)"
            [placeholder]="'misc.search' | translate"
          />
        </div>
      }
      <!-- Match data found -->
      @if (searchable && matchDataSource?.data?.length) {
        <div>
          <div class="button-list-match-title">
            <p>{{ "searchbarSite.match" | translate }}</p>
          </div>
          <div
            (click)="$event.stopPropagation()"
            class="button-list-match-table"
          >
            <div class="filter-site-list">
              <mat-table #table [dataSource]="matchDataSource">
                <ng-container matColumnDef="checkedItem">
                  <mat-header-cell *matHeaderCellDef matSort>
                    {{ displayedColumns[0] }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-checkbox
                      [disabled]="
                        maxItems <= checkedData.length && !element.checked
                      "
                      color="primary"
                      [checked]="element.checked"
                      (change)="manageItem(element, $event)"
                      (click)="$event.stopPropagation()"
                    >
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="key">
                  <mat-header-cell *matHeaderCellDef>
                    {{ displayedColumns[1] }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{
                      element.labelKey
                        ? (element.labelKey | translate: element.labelParams)
                        : element.keyDisplayed
                    }}
                  </mat-cell>
                </ng-container>
                <mat-row
                  *matRowDef="let row; columns: displayedColumns; element"
                  [ngClass]="{
                    'row-checked': row.checked,
                    'row-disabled':
                      maxItems <= checkedData.length && !row.checked
                  }"
                  (click)="manageItem(row, $event)"
                ></mat-row>
              </mat-table>
            </div>
          </div>
          <div class="button-list-match-title">
            <p>{{ "searchbarSite.results" | translate }}</p>
          </div>
        </div>
      }
      @if (!data?.length) {
        <div class="menu-empty">
          @if (dataFetched) {
            <p>{{ "misc.empty" | translate }}</p>
          }
          @if (dataLoading) {
            <mat-spinner [diameter]="16"></mat-spinner>
          }
        </div>
      }
      @if (data?.length) {
        <div
          #listSidebar
          [ngClass]="{
            'list-sidebar': true,
            'match-active': matchDataSource?.data?.length
          }"
          [infiniteScroll]="loadMore"
          [scrollRatio]="0.66"
          [initScrollThreshold]="200"
        >
          @if (!isEmpty) {
            <mat-table
              #table
              [dataSource]="dataSource"
              class="button-list-table"
            >
              <ng-container matColumnDef="checkedItem">
                <mat-header-cell *matHeaderCellDef matSort>
                  {{ displayedColumns[0] }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-checkbox
                    [disabled]="
                      maxItems <= checkedData.length && !element.checked
                    "
                    color="primary"
                    [checked]="element.checked"
                    (change)="manageItem(element, $event)"
                    (click)="$event.stopPropagation()"
                  >
                  </mat-checkbox>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="key">
                <mat-header-cell *matHeaderCellDef>
                  {{ displayedColumns[1] }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{
                    element.labelKey
                      ? (element.labelKey | translate: element.labelParams)
                      : element.keyDisplayed
                  }}
                </mat-cell>
              </ng-container>
              <mat-row
                *matRowDef="let row; columns: displayedColumns; element"
                [ngClass]="{
                  'row-checked': row.checked,
                  'row-disabled': maxItems <= checkedData.length && !row.checked
                }"
                (click)="manageItem(row, $event)"
              ></mat-row>
            </mat-table>
          }
          @if (data.length === 0 && label === "addIncident") {
            <p class="empty-p">
              {{ "misc.empty" | translate }}
            </p>
          }
        </div>
      }
    </div>
  }

  @if (type === "radio" && !isEmpty) {
    <div (click)="$event.stopPropagation()">
      <mat-radio-group
        class="button-list-radio-group"
        (change)="manageItemRadio($event)"
        [(ngModel)]="radioItem"
      >
        @for (item of radioData; track $index) {
          <mat-radio-button class="button-list-radio-item" [value]="item">{{
            interpolatePathTranslate(item) | translate
          }}</mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }

  @if (type === "dateRange") {
    <div class="range-filter" (click)="$event.stopPropagation()">
      <div class="range-container">
        <app-date-picker
          [placeholderPath]="'datepicker.start'"
          [selectedDate]="dateRangeData[0]"
          (date)="manageDates('start', $event)"
        ></app-date-picker>
        <app-date-picker
          [placeholderPath]="'datepicker.end'"
          [selectedDate]="dateRangeData[1]"
          (date)="manageDates('end', $event)"
        ></app-date-picker>
      </div>
    </div>
  }

  @if (type === "range") {
    <div
      class="range-filter"
      (click)="$event.stopPropagation()"
      (keydown.tab)="$event.stopPropagation()"
      (keydown.shift.tab)="$event.stopPropagation()"
    >
      <div class="range-container">
        <div class="range-item">
          <div class="range-txt">
            {{ "filter.statusDays.start" | translate }}
          </div>
          <div class="range-field">
            <mat-form-field appearance="outline">
              <input
                class="range-input"
                matInput
                max="361"
                type="number"
                (input)="manageRange('start', $event)"
                [(ngModel)]="rangeValues.start"
              />
            </mat-form-field>
            <span class="range-unit">{{ "sideSite.days" | translate }}</span>
          </div>
        </div>
        <div class="range-item">
          <div class="range-txt">
            {{ "filter.statusDays.end" | translate }}
          </div>
          <div class="range-field">
            <mat-form-field appearance="outline">
              <input
                class="range-input"
                matInput
                max="361"
                type="number"
                (input)="manageRange('end', $event)"
                [(ngModel)]="rangeValues.end"
              />
            </mat-form-field>
            <span class="range-unit">{{ "sideSite.days" | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (type === "colorStatus") {
    <div (click)="$event.stopPropagation()">
      <div #listSidebar class="list-sidebar">
        <mat-table #table [dataSource]="dataSource" class="button-list-table">
          <ng-container matColumnDef="checkedItem">
            <mat-header-cell *matHeaderCellDef matSort>
              {{ displayedColumns[0] }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-checkbox
                color="primary"
                [checked]="element.checked"
                (change)="manageColorStatusItem(element, $event)"
                (click)="$event.stopPropagation()"
              >
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="key">
            <mat-header-cell *matHeaderCellDef>
              {{ displayedColumns[1] }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span
                class="status-pastille"
                [ngClass]="markerColorClass(element.marker)"
              ></span>
              {{ "misc.status." + element.keyDisplayed | translate }}
            </mat-cell>
          </ng-container>

          <mat-row
            *matRowDef="let row; columns: displayedColumns; element"
            [ngClass]="{ 'row-checked': row.checked }"
            (click)="manageColorStatusItem(row, $event)"
          ></mat-row>
        </mat-table>
      </div>
    </div>
  }
</ng-template>
